export default "__VITE_ASSET__x1523_ZB__"